module.exports = __webpack_public_path__ + "img/product_jackpot.82e9d89.webp";